import React from 'react'
import { useNavigate } from 'react-router-dom'

import DangerousIcon from '@mui/icons-material/Dangerous'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import { Button } from '@mui/material'
import LoyaltyIcon from '@mui/icons-material/Loyalty'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { categories, getRandomValue } from './components/Categories'

import Header from '../../components/header/Header'
import styles from './Rewards.module.scss'

export default function Rewards() {
  const navigate = useNavigate()

  const selectCategory = (categoryId: number) => {
    navigate(`/rewards/${categoryId}`)
  }

  return (
    <div className={styles.rewards}>
      <Header />
      <div className={styles.rewardsWrapper}>
        <div className="d-flex justify-content-between align-items-baseline mt-3">
          <div className="flex-column">
            <h4>Olá Roberio, seja bem-vindo!</h4>
            <p className="mt-3">
              Selecione para visualizar os benefícios disponíveis
            </p>
          </div>
          <div className="d-flex flex-column">
            <div className={styles.statusButtonsWrapper}>
              <div className={`${styles.statusButton} ${styles.available}`}>
                <div className={`${styles.icon} ${styles.available}`}>
                  <LoyaltyIcon />
                </div>
                <div className={styles.text}>
                  <small>DISPONÍVEL</small>
                  <h5 className="mb-0 ">{getRandomValue(0, 50)}</h5>
                </div>
              </div>
              <div className={`${styles.statusButton} ${styles.rewarded}`}>
                <div className={`${styles.icon} ${styles.rewarded}`}>
                  <EmojiEventsIcon />
                </div>
                <div className={styles.text}>
                  <small>RESGATADOS</small>
                  <h5 className="mb-0 ">{getRandomValue(0, 50)}</h5>
                </div>
              </div>
              <div className={`${styles.statusButton} ${styles.warning}`}>
                <div className={`${styles.icon} ${styles.warning}`}>
                  <ScheduleIcon />
                </div>
                <div className={`${styles.text} me-1`}>
                  <small>EXP. EM BREVE</small>
                  <h5 className="mb-0">{getRandomValue(0, 50)}</h5>
                </div>
              </div>
              <div className={`${styles.statusButton} ${styles.error}`}>
                <div className={`${styles.icon} ${styles.error}`}>
                  <DangerousIcon />
                </div>
                <div className={styles.text}>
                  <small>EXPIRADOS</small>
                  <h5 className="mb-0 ">{getRandomValue(0, 50)}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="mt-2" />
        <div className={styles.categoriesTableWrapper}>
          <div className={styles.categoriesTable}>
            {categories.map(category => (
              <div
                key={category.id}
                role="presentation"
                className={`${styles.category}`}
                onClick={() => selectCategory(category.id)}
              >
                {category.icon}
                <h6 className="mt-2">{category.name}</h6>
              </div>
            ))}
          </div>
          <small className="mt-3 text-center">
            1 resgate por categoria (não cumulativo)
          </small>
          <div className="d-flex justify-content-center mt-4">
            <Button
              variant="contained"
              color="primary"
              className="mt-0"
              onClick={() => navigate('/rewards/rewarded')}
            >
              MEUS RESGATES
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="mt-0 ms-3"
              style={{ width: 141 }}
              onClick={() => navigate('/rewards/history')}
            >
              HISTÓRICO
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
